<script lang="ts">
export default {
  name: 'KkTargetStoresModal',
}
</script>

<script lang="ts" setup>
import { KkModal, KkButton } from '../../../components/base'

export interface Props {
  isVisible: boolean
  storeNames: string[]
}

export interface Emits {
  (e: 'close'): void
}

const props = withDefaults(defineProps<Props>(), {
  isVisible: false,
  storeNames: () => []
})
const emit = defineEmits<Emits>()
</script>

<template>
  <KkModal :is-visible="props.isVisible" width="50%" @change="emit('close')">
    <div class="content__header">
      {{ $t('labels.targetStores') }}
    </div>
    <div class="content__body">
      <div v-for="(storeName, index) in storeNames" :key="index" class="item">
        {{ storeName }}
      </div>
    </div>
    <div class="content__footer">
      <div class="buttonGroup">
        <div class="buttonGroup__item">
          <KkButton color="secondary" outlined :text="$t('labels.close')" @click="emit('close')" />
        </div>
      </div>
    </div>
  </KkModal>
</template>

<style lang="scss" scoped>
@import "../../../../../stylesheets/biz_spa/foundation/var";
.content {
  &__header {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 20px 32px;
    border-bottom: 1px solid $color-base-c;
    font-size: 16px;
    line-height: 1.5;
  }
  &__footer {
    padding: 32px;
    border-top: 1px solid $color-base-c;
  }
  &__body {
    height: 50vh;
    padding: 32px;
    overflow-y: scroll;
    .item {
      padding: 0 12px 12px 0;
    }
  }
  &__footer {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
